import { DeleteModal, IconFont } from '@/components'
import { Typography, Timeline, Table, message } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { Fragment, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useGetDetailEvent, useGetThrough } from './utils'
import { useSearchParams } from 'react-router-dom'
import { Message } from '@/components/message'
import { t } from '@/i18n'

interface CommonProps {
  title?: string
  show?: boolean
  detail: any
}

const CreateTask = (props: CommonProps) => {
  const { detail } = props
  return (
    <>
      <Timeline.Item
        dot={
          <IconContainer>
            <IconFont type="icon-chuangjianrenwu" />
          </IconContainer>
        }
      >
        <TimelineContent>
          <TimelineContentTitle>
            <div>{t('创建任务')}</div>
            <div>{detail.time}</div>
          </TimelineContentTitle>
        </TimelineContent>
      </Timeline.Item>
    </>
  )
}

const SendEmail = (props: CommonProps) => {
  const { detail } = props
  return (
    <>
      <Timeline.Item
        dot={
          <IconContainer>
            <IconFont style={{ fontSize: 16 }} type="icon-fasongyoujian" />
          </IconContainer>
        }
      >
        <TimelineContent>
          <TimelineContentTitle>
            <div>{t('发送邮件')}</div>
            <div>{detail.time}</div>
          </TimelineContentTitle>
        </TimelineContent>
      </Timeline.Item>
    </>
  )
}

const SeeLink = (props: CommonProps) => {
  const { detail } = props
  let info
  try {
    info = JSON.parse(detail.detail)
  } catch (error) {
    // Message.error('发生了一个意料之外的错误')
  }
  return (
    <>
      <Timeline.Item
        dot={
          <IconContainer>
            <IconFont style={{ fontSize: 16 }} type="icon-yidudianjihou" />
          </IconContainer>
        }
      >
        <TimelineContent>
          <TimelineContentTitle>
            <div>{t('查看邮件')}</div>
            <div>{detail.time}</div>
          </TimelineContentTitle>
        </TimelineContent>
      </Timeline.Item>
    </>
  )
}
const ClickLink = (props: CommonProps) => {
  const { detail } = props

  let info
  try {
    info = JSON.parse(detail.detail)
  } catch (error) {
    // Message.error('发生了一个意料之外的错误')
  }
  return (
    <>
      <Timeline.Item
        dot={
          <IconContainer>
            <IconFont style={{ fontSize: 16 }} type="icon-shubiaodianji" />
          </IconContainer>
        }
      >
        <TimelineContent>
          <TimelineContentTitle>
            {/* <div>点击链接/打开附件</div> */}
            <div>{t('点击链接')}</div>
            <div>{detail.time}</div>
          </TimelineContentTitle>
          <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
            {t('IP地址：')}
            {info?.browser?.address}
          </Typography.Paragraph>
          <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
            User-Agent：{info?.browser?.['user-agent']}
          </Typography.Paragraph>
        </TimelineContent>
      </Timeline.Item>
    </>
  )
}
const OpenAccessory = (props: CommonProps) => {
  const { detail } = props
  let info
  try {
    info = JSON.parse(detail.detail)
  } catch (error) {
    // Message.error('发生了一个意料之外的错误')
  }
  return (
    <>
      <Timeline.Item
        dot={
          <IconContainer>
            <IconFont style={{ fontSize: 16 }} type="icon-wenjian11" />
          </IconContainer>
        }
      >
        <TimelineContent>
          <TimelineContentTitle>
            {/* <div>点击链接/打开附件</div> */}
            <div>{t('打开附件')}</div>
            <div>{detail.time}</div>
          </TimelineContentTitle>
          <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
            {t('IP地址：')}
            {info?.browser?.address}
          </Typography.Paragraph>
          <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
            User-Agent：{info?.browser?.['user-agent']}
          </Typography.Paragraph>
        </TimelineContent>
      </Timeline.Item>
    </>
  )
}
const SubmitData = (props: CommonProps) => {
  const [openTable, setOpenTable] = useState(true)
  const { detail } = props

  let info
  try {
    info = JSON.parse(detail.detail)
  } catch (error) {
    // Message.error('发生了一个意料之外的错误')
  }
  let data: { [key in string]: any }[] = []
  Object.keys(info?.payload || info?.browser || {}).forEach((item, index) => {
    data.push({
      key: index,
      address: item,
      value: info.browser[item] || info?.payload?.[item],
    })
  })
  const columns: ColumnsType<any> = [
    {
      title: <div style={{ paddingLeft: 5 }}>{t('字段')}</div>,
      dataIndex: 'address',
      render: value => <div style={{ paddingLeft: 5 }}>{value}</div>,
    },
    {
      title: <div style={{ paddingLeft: 5 }}>{t('值')}</div>,
      dataIndex: 'value',
      render: value => <div style={{ paddingLeft: 5 }}>{value}</div>,
    },
  ]

  return (
    <>
      <Timeline.Item
        dot={
          <IconContainer>
            <IconFont type="icon-shangchuanshuju" />
          </IconContainer>
        }
      >
        <TimelineContent>
          <TimelineContentTitle>
            <div>{t('提交数据')}</div>
            <div>{detail.time}</div>
          </TimelineContentTitle>
          <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
            Address：{info?.browser?.address}
          </Typography.Paragraph>
          <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
            User-Agent：{info?.browser?.['user-agent']}
          </Typography.Paragraph>
          {data?.length > 0 && (
            <>
              <Typography.Link onClick={() => setOpenTable(!openTable)}>
                {openTable ? t('收起') : t('查看详情')}
              </Typography.Link>
              {openTable && (
                <div style={{ marginTop: '13px' }}>
                  <Table pagination={false} columns={columns} dataSource={data} rowKey="key" />
                </div>
              )}
            </>
          )}
        </TimelineContent>
      </Timeline.Item>
    </>
  )
}

interface ListExpandableProps {
  dateline: any[]
  id: string
  email: string
  sid: string
  detailList: any
  seeThrough?: number
  change: any
  status: number
}

export const ListExpandable = (props: ListExpandableProps) => {
  const [searchParams] = useSearchParams()
  const ids = searchParams.get('id')
  const { dateline, id, sid, email, detailList, seeThrough = false, change, status } = props

  useEffect(() => {
    // console.log(id)
    if (email || id || (sid && detailList)) {
      getDatetailEvent({ email, campaign_id: ids, sid }).catch(_ => {})
    }
  }, [email, ids, sid, detailList])
  const [show, setShow] = useState(seeThrough === 2 && status !== 3)
  useEffect(() => {
    // console.log(seeThrough, status, show)
    setShow(seeThrough === 2 && status !== 3)
  }, [seeThrough, status])
  const [datetailEvent, datetailEventLoad, getDatetailEvent] = useGetDetailEvent()
  const [through, setThrough] = useState({ visible: false, id: null })
  const [modalVisible, setModalVisible] = useState({ visible: false, time: null })
  const [getThrough, throughLoading] = useGetThrough()
  const SeeThroughButton = p => {
    const { data, checked = false, show = false } = p
    const handleClick = () => {
      if (checked) {
        return
      }
      setModalVisible({ visible: true, time: data })
      // console.log(data, checked)
    }
    return (
      <>
        {show && (
          <Timeline.Item dot={<IconDot />}>
            <TimelineContentButton checked={checked} onClick={handleClick}>
              {t('识破钓鱼')}
            </TimelineContentButton>
          </Timeline.Item>
        )}
      </>
    )
  }
  return (
    <ListExpandableContainer>
      {/*<Typography.Paragraph>时间线</Typography.Paragraph>*/}
      <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
        Email：{email}
      </Typography.Paragraph>
      <Typography.Paragraph style={{ fontSize: 13, color: '#666666', lineHeight: '18px' }}>
        {t('身份标识：')}
        {sid}
      </Typography.Paragraph>
      <TimelineContainer>
        <Timeline>
          {(datetailEvent?.items || []).map((item, index) => (
            <Fragment key={`${id}${index}`}>
              {item.action === 1 && <CreateTask detail={item} />}
              {item.action === 2 && (
                <>
                  <SendEmail detail={item} />
                  <SeeThroughButton show={show} data={item.time} />
                </>
              )}
              {item.action === 3 && (
                <>
                  <SeeLink detail={item} />
                  <SeeThroughButton show={show} data={item.time} />
                </>
              )}
              {item.action === 4 && (
                <>
                  <ClickLink detail={item} />
                  <SeeThroughButton show={show} data={item.time} />
                </>
              )}
              {item.action === 5 && (
                <>
                  <OpenAccessory detail={item} />
                  <SeeThroughButton show={show} data={item.time} />
                </>
              )}
              {item.action === 6 && (
                <>
                  <SubmitData detail={item} />
                  <SeeThroughButton show={show} data={item.time} />
                </>
              )}
              {item.action == -1 && <SeeThroughButton show checked data={item.time} />}
            </Fragment>
          ))}
        </Timeline>
      </TimelineContainer>
      <DeleteModal
        onOk={() => {
          // console.log('id in expand', id)
          // change(id)
          getThrough({ sid: sid, time: modalVisible.time })
            .then(() => {
              change(sid)
              setModalVisible({ visible: false, time: null })
            })
            .catch(_ => {
              setModalVisible({ visible: false, time: null })
            })
        }}
        visible={modalVisible.visible}
        title={t('提示')}
        confirmLoading={throughLoading}
        text={t('请确认该测试者已识破钓鱼邮件，操作将影响评估结果，是否继续？')}
        // confirmLoading={deleteTaskLoading}
        onCancel={() => {
          setModalVisible({ visible: false, time: null })
        }}
      />
    </ListExpandableContainer>
  )
}
const ListExpandableContainer = styled.div`
  padding-left: 25px;
  padding-right: 20px;
`

const IconDot = styled.div`
  width: 12px;
  height: 12px;
  background: #0e42d2;
  box-shadow: 0px 2px 6px 0px rgba(51, 51, 51, 0.15);
  border: 2px solid #ffffff;
  border-radius: 6px;
`
const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #2973ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
`
const TimelineContainer = styled.div`
  margin-top: 24px;
  .ant-timeline-item {
    &:last-child {
      .ant-timeline-item-tail {
        display: none;
      }
    }
  }
`

const TimelineContent = styled.div`
  padding-left: 10px;

  .ant-table tr .ant-table-cell {
    height: 48px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
`

const TimelineContentTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 13px;
`
interface ButtonProps {
  checked: boolean
}

const TimelineContentButton = styled.div<ButtonProps>`
  display: inline-block;
  padding: 4px 6px;
  font-size: 12px;
  cursor: ${props => (props.checked ? 'normal' : 'pointer')};
  background: ${props => (props.checked ? '#7686a2' : '#f1f3f8')};
  color: ${props => (props.checked ? '#fff' : '#333333')};
  //background: #f1f3f8;
  margin-left: 10px;
  border-radius: 6px;
  //width: 72px;
  margin-top: -8px;
  margin-bottom: 13px;
`
